import React, { Fragment } from 'react';
import styled from 'styled-components';
import { PointOfSaleContext } from '@olxbr/mojo-jojo/contexts';

import Product from './product/Product';
import ProductPicker from './product-picker/ProductPicker';
import TelesalesMessage from '../core/components/telesales-message/TelesalesMessage';
import './Products.css';
import QuestionsBox from '../core/components/questions/QuestionsBox';
import MyAdsButton from '../core/components/MyAdsButtonContainer';

const Wrapper = styled.section`
  width: 100%;
  display: block;
  margin: 0 auto;
  background-color: '#f9f9f9';
  @media(min-width:1000px) {
    width: 970px;
  }
`;

const StepButtonWrapper = styled.div`
  text-align: center;
  margin: 20px 0px;
`;

const Products = () => (
  <PointOfSaleContext>
    {({
      contentData, productsData, posData, userData,
    }) => (
      <Fragment>
        <Wrapper>
          <section className="box-packages visible-only-on-large block-on-large">
            {productsData.highlights.map(product =>
              <Product key={product.title} product={product} type={posData.parentName} isFee={posData.limitExceeded} />)}
          </section>
          <section className="mobile-box-packages hidden-only-on-large">
            <ProductPicker products={productsData.highlights} type={posData.type} isFee={posData.limitExceeded} />
          </section>
          <StepButtonWrapper>
            <MyAdsButton>{posData.alreadyBoughtProduct ? contentData.productAlreadyBoughtContinueMessage : 'Continuar sem destaque'}</MyAdsButton>
          </StepButtonWrapper>
          {posData.type === 'fee-insertion-telesales' && <TelesalesMessage email={userData.email} />}
        </Wrapper>
        {posData.type === 'fee-insertion' && <QuestionsBox questions={contentData.questions} />}
      </Fragment>
    )}
  </PointOfSaleContext>
);

export default Products;
